/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of gang timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/
import React from 'react';
import { NumberInput, SelectField, SelectBlock, Select } from '../../inputs';
import { packageDashForm } from '../../../utils';

const GangFormAutoFill = ({ id, fields, blocks, autoFillGangTimesheet, fetchBlocksByField }) => {
  return (
    <div className="row">
      <form id={'autofill-form'} onSubmit={(e) => e.preventDefault()}>
        <div className="col s12 m12 l12">
          <Select id={`autofill-count`} label={'Input Count'}
            opts={[{ val: 1, label: 1 },{ val: 2, label: 2 },{ val: 3, label: 3 },
            { val: 4, label: 4 },{ val: 5, label: 5 }]} />
        </div>
        <div className="col s12 m12 l12">
          <NumberInput id={`autofill-hours`} min={"0"} max={"8"} step={'0.1'} label={'Hours'} />
        </div>
        <div className="col s12 m12 l12">
          <NumberInput id={`autofill-trees`} min={"0"} max={"75"} step={'0.1'} label={'Trees'} />
        </div>
        <div className="col s12 m12 l12">
          <NumberInput id={`autofill-bags`} min={"0"} max={"25"} step={'0.1'} label={'Bags'} />
        </div>
        <div className="col s12 m12 l12">
          <SelectField id={`autofill-field`} label={'Field'} opts={fields}
            onChange={(event) => fetchBlocksByField(event.target.value)} />
        </div>
        <div className="col s12 m12 l12">
          <SelectBlock id={`autofill-block`} label={'Block'} opts={blocks} />
        </div>
        <div className="col s12 m12 l12"><br />
          <center>
            <button className="btn waves-light waves-effect"
              onClick={() => autoFillGangTimesheet(packageDashForm('autofill-form'))}>
              Auto-Fill
            </button>
          </center>
        </div>
      </form>
    </div>
  );
};

export default GangFormAutoFill;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/gang_autofill_form.js